import { createSlice } from '@reduxjs/toolkit';
import uuid from 'uuid';
import { stateName } from './constants';
export const initialState = {
  suggestions: [],
  shouldSetSuggestions: true,
  suggestionsListId: null
};

const fetchSuggestionsSuccess = (draft, action) => {
  const {
    suggestions
  } = action.payload;
  const {
    shouldSetSuggestions
  } = draft;

  if (shouldSetSuggestions) {
    draft.suggestions = suggestions;
    draft.suggestionsListId = uuid.v4();
  }
};

const fetchSuggestionsFailure = (draft, action) => {
  const {
    fallbackSuggestions
  } = action.payload;
  const {
    shouldSetSuggestions
  } = draft;

  if (shouldSetSuggestions) {
    draft.suggestions = fallbackSuggestions;
    draft.suggestionsListId = uuid.v4();
  }
};

const clearSuggestions = draft => {
  draft.suggestions = [];
  draft.shouldSetSuggestions = false;
  draft.suggestionsListId = null;
};

const fetchSuggestionsRequest = draft => {
  draft.shouldSetSuggestions = true;
};

const packageSizesSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    fetchSuggestionsRequest: {
      reducer: fetchSuggestionsRequest,
      prepare: (payload, meta) => ({
        payload,
        meta
      })
    },
    fetchSuggestionsSuccess,
    fetchSuggestionsFailure,
    clearSuggestions
  }
});
export const {
  actions
} = packageSizesSlice;
export const plug = {
  [stateName]: packageSizesSlice.reducer
};
export default packageSizesSlice.reducer;